module.exports = __webpack_public_path__ + "static/media/trabajo.75cbed32.svg";